/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { PaginationMetaDto } from './pagination-meta-dto';
import { UserDto } from './user-dto';
 /**
 *
 *
 * @export
 * @interface UserPaginatedResponseDto
 */
export interface UserPaginatedResponseDto {

    /**
     * @type {Array<UserDto>}
     * @memberof UserPaginatedResponseDto
     */
    data: Array<UserDto>;

    /**
     * @type {PaginationMetaDto}
     * @memberof UserPaginatedResponseDto
     */
    meta: PaginationMetaDto;
}
